
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  IBaseTopic,
  TopicDisplayHelpers,
  TopicStatus,
  TopicType,
  QuestionCategory,
  QuestionPriority,
} from '@/models/insights';
import { DataFreshness } from '@/models/insights/Topic';

@Component
export default class TopicCard extends Vue {
  @Prop({ required: true })
  public topic!: IBaseTopic;

  @Prop({ default: false })
  public compact!: boolean;

  @Prop({ default: false })
  public loading!: boolean;


  // Helper methods to handle different topic interface types
  public getTopicName(): string {
    return (this.topic as any).name || (this.topic as any).display_name || 'Untitled Topic';
  }


  public getTopicIcon(): string {
    // Check for direct icon property (legacy interface)
    if ((this.topic as any).icon) {
      return (this.topic as any).icon;
    }

    // Use metadata icon if available
    if ((this.topic as any).metadata?.icon) {
      return (this.topic as any).metadata.icon;
    }

    // Fallback to type-based icons
    const topicType = (this.topic as any).type;
    if (topicType && Object.values(TopicType).includes(topicType)) {
      const typeIconMap: Record<TopicType, string> = {
        [TopicType.BUSINESS_METRICS]: 'mdi-chart-line',
        [TopicType.OPERATIONAL_INSIGHTS]: 'mdi-cog-outline',
        [TopicType.STRATEGIC_ANALYSIS]: 'mdi-strategy',
        [TopicType.PERFORMANCE_MONITORING]: 'mdi-speedometer',
        [TopicType.TREND_ANALYSIS]: 'mdi-trending-up',
        [TopicType.COMPARATIVE_ANALYSIS]: 'mdi-compare-horizontal',
        [TopicType.FORECASTING]: 'mdi-crystal-ball',
        [TopicType.CUSTOM]: 'mdi-puzzle-outline',
      };
      return typeIconMap[topicType as TopicType];
    }

    return 'mdi-lightbulb-outline';
  }

  public getTopicColor(): string {
    // Check for direct color property (legacy interface)
    if ((this.topic as any).color) {
      return (this.topic as any).color;
    }

    // Use metadata color if available
    if ((this.topic as any).metadata?.color) {
      return (this.topic as any).metadata.color;
    }

    // Default color
    return 'primary';
  }


  // Event handlers
  public handleCardClick(): void {
    this.$emit('click', this.topic);
  }
}
